import { useState, useCallback, useRef } from 'react';

const useRerender = () => {
  const [, setState] = useState(0);
  return useCallback(() => setState((state) => state + 1), []);
};

export const useToggleState = (selected_os_versions_numbers = []) => {
  const [stateSet] = useState(() => new Set(selected_os_versions_numbers));
  const state = [...stateSet.values()];
  const rerender = useRerender();
  const saveBtnFlag = useRef(true);
  const isActive = useCallback((version) => stateSet.has(version), [stateSet]);

  const toggle = useCallback(
    (checkBoxValue, ...versions) => {
      versions.forEach((version) => {
        isActive(version) ? stateSet.delete(version) : stateSet.add(version)[isActive];
      });
      saveBtnFlag.current = false;
      rerender();
    },
    [isActive],
  );

  const toggleAllOff = useCallback(() => {
    stateSet.clear();
    rerender();
  }, [stateSet, rerender]);

  return { isActive, state, toggle, toggleAllOff, saveBtnFlag };
};
